<template>
  <div>
	<h2 class="text-capitalize" v-html="projectHeading"></h2>
	<p class="fz-24 text-center animated fadeIn p-64" v-if="showNoResults">No Search Results</p>
	<div class="row" v-if="!showNoResults">
		<div class="col-lg-4 project-item my-3 animated fadeInUp" v-for="post in posts" :key="post.ID">
			<a class="d-block position-relative" :href="post.link" :aria-label="post.post_title">
				<div class="bg-image-wrap">
					<div class="bg-image p-80 bg-light-gray" :style="{backgroundImage: `url(${post.image_url})`}"></div>
				</div>
				<div class="overlay d-flex align-items-left justify-content-center flex-column px-4">
					<!-- <p class="mb-0 text-uppercase" v-html="post.project_market"></p> -->
					<p class="mb-0 fz-32 font-bold text-uppercase">{{post.post_title}}</p>
				</div>
			</a>
		</div>
	</div>
    <div class="row">
      <button class="btn btn-windward-blue mx-auto" @click.stop.prevent="loadMore()" v-if="showLoadMore">Load More Projects</button>
    </div>
  </div>
</template>
<script>
const axios = require('axios');
export default {
	created(){
		this.q = this.getUrlParam('q','');
		if(this.q){
			this.getTermBySlug(this.q)
				.then(slug => {
					// console.log(slug.data);
					this.projectHeading = slug.data.name + " Projects";
			});
		}
		this.getPosts();
		this.showLoadMore = false;
	},
	mounted(){
		this.showLoadMore = true;
	},
	methods: {
		getPostRequest(term = 'all', page = 0, take = 12, search = ''){
			this.showNoResults = false;
			return axios.get(`${this.api.prefix}${this.api.posts}?page=${page}&take=${take}&term=${term}&search=${search}&q=${this.q}`);
		},
		getPosts(term = 'all', page = 0, take = 12){
			this.$set(this, 'loading', true);
				this.getPostRequest(term, page, take)
				.then(posts => {
					if(posts.data.length == 0 ){
						this.showLoadMore = false;
						if(page==0){
							this.showNoResults = true;
						}
					} else{
						this.$set(this, 'loading', false);
						this.delayedInsert(this.posts, posts.data);
						if(posts.data.length < take){
							this.showLoadMore = false;
						}
					}
				}).catch(err => {
					this.$set(this, 'loading', false);
				});
		},
		loadMore(){
			this.$set(this, 'page', this.page + 1);
			this.getPosts([this.term], this.page);
		},
		searchPosts(searchString){
			this.q = '';
			this.projectHeading = "Searching all projects for: " + searchString;
			this.$set(this, 'term', 'all');
			this.$set(this, 'page', 0);
			this.$set(this, 'searchString', searchString);
			this.$set(this, 'loading', true);
			this.getPostRequest([this.term], 1, 12, searchString).then(response => {
				this.$set(this, 'loading', false);
				this.$set(this, 'posts', []);
				if(response.data.length == 0){
					// console.log(response.data);
					this.showLoadMore = false;
					if(this.page==0){
						this.showNoResults = true;
					}
				}
				this.delayedInsert(this.posts, response.data);
				if(response.data.length < 12){
					this.showLoadMore = false;
				} else{
					setTimeout(() => {
						this.showLoadMore = true;
					}, 300);
				}
			});
			app.scroll.toTarget('.section-projects');
		},
		setTerm(slug, heading){
			this.q = '';
			this.projectHeading = heading + " Projects";
			this.$set(this, 'term', slug);
			this.$set(this, 'page', 1);
			this.$set(this, 'loading', true);
			this.getPostRequest(this.term).then(response => {
				this.$set(this, 'loading', false);
				this.$set(this, 'posts', []);
				if(response.data.length == 0){
					this.showNoResults = true;
				}
				this.delayedInsert(this.posts, response.data);
				if(response.data.length < 12){
					this.showLoadMore = false;
				} else{
					setTimeout(() => {
						this.showLoadMore = true;
					}, 300);
				}
			});
			app.scroll.toTarget('.section-projects');
		},
		getTermBySlug(slug){
			return axios.get(`${this.api.prefix}term/?slug=${slug}`);
		},
		delayedInsert(subject, items){
			const [item, ...rest] = items;
			subject.push(item);
			if (rest.length > 0){
				setTimeout(() => {
					this.delayedInsert(subject, rest);
				}, 80);
			}
		},
		setMode(mode){
			this.$set(this, 'mode', mode);
		},
		json(j){
			return JSON.stringify(j);
		},
		getUrlParam(parameter, defaultvalue){
			var urlparameter = defaultvalue;
			if(window.location.href.indexOf(parameter) > -1){
				urlparameter = this.getUrlVars()[parameter];
				}
			return urlparameter;
		},
		getUrlVars() {
			var vars = {};
			var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
				vars[key] = value;
			});
			return vars;
		}
	},
	data() {
		return {
			posts: [],
			categories: [],
			term: 'all',
			loading: true,
			api: {
				prefix: '/wp-json/usdp/v1/',
				posts: 'projects/'
			},
			page: 1,
			// searchString: '',
			showNoResults: false,
			showLoadMore: false,
			mode: 'grid',
			projectHeading: 'All Projects',
			q: ''
		};
	}
}
</script>
